import React from 'react';

export default function InputRadioLabel({ children }) {
  return (
    <div
      data-component-name='InputRadioLabel'
      className='rounded-full h-6 whitespace-nowrap text-blue-500 hover:text-white-400 hover:bg-button-gradient bg-blue-50 flex items-center px-2.5 text-base group-data-[state=on]:bg-button-gradient group-data-[state=on]:text-white-400'
    >
      {children}
    </div>
  );
}
